import classNames from "classnames";
import { BuilderComponentProps } from "../BuilderInterface";
import "./style.scss";
import { getCompoundStyle } from "../helpers";

import { useRef } from "react";

const BuilderPage: React.FC<BuilderComponentProps> = ({
    node,
    children,
    actionCallbacks,
    builderProps
}: BuilderComponentProps) => {
    const { id, attr } = node;

    const div = useRef<HTMLDivElement>(null);

    const builderSectionClass = classNames("builder-page", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { selectedMenu, extraChild, selectCallback, outlineCallback, onDragOverCapture } = builderProps;

        return (
            <div
                {...attr}
                ref={div}
                className={builderSectionClass}
                style={getCompoundStyle({ node })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragOverCapture={e => onDragOverCapture?.(e, id, div.current as HTMLDivElement)}
            >
                {extraChild}
                {children}
                {selectedMenu}
            </div>
        );
    } else {
        return (
            <div {...attr} {...actionCallbacks} className={builderSectionClass} style={getCompoundStyle({ node })}>
                {children}
            </div>
        );
    }
};

export default BuilderPage;
